"use strict";

// Variables
var contactForm = document.getElementById('js-contact');
var loader = document.querySelector('.js-loader');
var msgValid = document.querySelector('.js-msg-valid');
var msgError = document.querySelector('.js-msg-error'); // Check required fields

function validateFields(target, action) {
  var form = document.getElementById(target);
  var data = new FormData(form);
  var xhr = new XMLHttpRequest();
  data.append('action', action);
  xhr.open('POST', ajaxurl);

  xhr.onload = function (event) {
    if (xhr.status === 200) {
      var fields = document.querySelectorAll('[data-error]');
      loader.classList.remove('visible');
      fields.forEach(function (fields) {
        fields.classList.remove('has-error');
      });
      submitForm();
    } else {
      msgError.style.display = 'block';
      Object.keys(JSON.parse(xhr.response)).map(function (key) {
        var errors = document.querySelector('[data-error=\'' + key + '\']');
        errors.classList.add('has-error');
      });
    }
  };

  loader.classList.remove('visible');
  xhr.send(data);
} // Submit the form
// function submitForm(e) {
//   console.log('submitForm')
//   e.preventDefault();
//   let form = document.getElementById('js-contact');
//   let data = new FormData(form);
//   let xhr = new XMLHttpRequest();
//   // let button = document.querySelector('.js-send');
//   let redirect = form.getAttribute('data-redirect');
//   data.append('action', 'validate_recaptcha');
//   xhr.open('POST', ajaxurl);
//   xhr.onload = function (event) {
//     if (xhr.status === 200) {
//       console.log(xhr.response);
//       // button.setAttribute('disabled', 'disabled');
//       // msgError.style.display = 'none';
//       // msgValid.style.display = 'block';
//       // window.location.replace(redirect);
//     }
//     else {
//       // button.setAttribute('disabled', false);
//       // msgValid.style.display = 'none';
//       // msgError.style.display = 'block';
//       // Object.keys(JSON.parse(xhr.response)).map(function (key) {
//       //   let errors = document.querySelector('[data-error=\'' + key + '\']');
//       //   errors.classList.add('has-error');
//       // });
//     }
//   }
//   loader.classList.remove('visible');
//   xhr.send(data);
// }


if (contactForm) {
  var inputFile = document.querySelector('.js-contact-input-file');
  var limit = inputFile.getAttribute('data-limit');

  inputFile.onchange = function () {
    inputFile.classList.remove('has-error');

    if (this.files[0].size > limit * 1024 * 1024) {
      inputFile.classList.add('has-error');
      this.value = "";
    }
  };

  contactForm.addEventListener('submit', function (event) {
    event.preventDefault();
    loader.classList.add('visible');
    msgValid.style.display = 'none';
    msgError.style.display = 'none';
    validateFields('js-contact', 'validate_fields_contact');
  });
}

if (document.getElementById('vue-contact')) {
  new Vue({
    el: '#vue-contact',
    // propsData: _objectSpread({}, document.getElementById("vue-application").dataset),
    // props: {
    //   sitekey: {
    //     type: String,
    //     "default": ''
    //   }
    // },
    data: function data() {
      return {
        grecaptcha_sitekey: '',
        form: {
          company: '',
          sex: '',
          name: '',
          job: '',
          email: '',
          phone: '',
          country: '',
          know: '',
          message: '',
          news_rgpd: '',
          attachments: [{
            file: '',
            name: ''
          }],
          grecaptcha_token: ''
        },
        errors: {
          company: '',
          sex: '',
          name: '',
          job: '',
          email: '',
          phone: '',
          country: '',
          know: '',
          message: '',
          news_rgpd: '',
          grecaptcha_token: ''
        },
        success: false,
        lang: 'fr',
        redirect: '',
        errorMessageFileSize: null,
        errorMessageInputRequired: null
      };
    },
    mounted: function mounted() {
      console.log('contact mounted'); // this.labelCv = this.$refs.labelCv.textContent;
      // this.labelLetter = this.$refs.labelLetter.textContent;

      this.lang = this.$refs.formcontact.dataset.lang;
      this.redirect = this.$refs.formcontact.dataset.redirect;
      window.recaptchaCallback = this.recaptchaCallback; // this.form.job = document.querySelector('input[name="job"]').value;

      this.grecaptcha_sitekey = this.$refs.formcontact.dataset.sitekey;
      this.errorMessageFileSize = this.lang === 'fr' ? 'Le fichier doit être inférieur à 3mo' : 'The file must be less than 3mb';
      this.errorMessageInputRequired = this.lang === 'fr' ? 'Ce champ est requis' : 'This field is required';
    },
    methods: {
      check: function check() {
        if (this.$refs.formcontact.checkValidity()) {
          return true;
        } else {
          this.$refs.formcontact.reportValidity();
          return false;
        }
      },
      // updateCV: function updateCV(event) {
      //   if (event.target.files[0].size < 3145728) {
      //     this.errors.cv = '';
      //     this.form.cv = event.target.files[0];
      //     event.target.nextElementSibling.textContent = event.target.files[0].name;
      //   } else {
      //     this.errors.cv = this.errorMessageFileSize;
      //   }
      // },
      // updateLetter: function updateLetter(event) {
      //   if (event.target.files[0].size < 3145728) {
      //     this.errors.letter = '';
      //     this.form.letter = event.target.files[0];
      //     event.target.nextElementSibling.textContent = event.target.files[0].name;
      //   } else {
      //     this.errors.letter = this.errorMessageFileSize;
      //   }
      // },
      resetErrors: function resetErrors() {
        this.errors = {
          name: '',
          lastname: '',
          email: '',
          message: '',
          job: '',
          cv: '',
          letter: '',
          rgpd: '',
          grecaptcha_token: ''
        };
      },
      getErrors: function getErrors(errors) {
        var data = {};
        var err = errors.response.data.data.params;

        if (Array.isArray(err)) {
          var name = err[0];
          this.getFirstError(name);

          var _iterator = _createForOfIteratorHelper(err),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var error = _step.value;
              data[error] = this.errorMessageInputRequired;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return data;
        } else {
          var _name = Object.keys(err)[0];
          this.getFirstError(_name);
          return Object.assign(this.errors, errors.response.data.data.params);
        }
      },
      getFirstError: function getFirstError(name) {
        var domRect = document.getElementsByName(name)[0].getBoundingClientRect();
        window.scroll({
          top: domRect.top + window.scrollY - 100,
          left: 0,
          behavior: "smooth"
        });
      },
      handleAddAttachments: function handleAddAttachments(event, index) {
        this.form.attachments[index].file = event.target.files[0];
        this.form.attachments[index].name = event.target.files[0].name;
        this.addAttachment();
      },
      addAttachment: function addAttachment(event) {
        this.form.attachments.push({
          file: '',
          name: ''
        });
      },
      getFileName: function getFileName(event) {
        if (event.name) {
          return event.name;
        } else {
          return '';
        }
      },
      submitForm: function submitForm(e) {
        var _this2 = this;

        e.preventDefault();
        grecaptcha.ready(function () {
          grecaptcha.execute(_this2.grecaptcha_sitekey, {
            action: 'contact'
          }).then(function (token) {
            _this2.form.grecaptcha_token = token;

            _this2.sendContactForm();
          });
        });
      },
      sendContactForm: function sendContactForm() {
        var _this = this; // e.preventDefault();


        this.resetErrors();

        if (this.check()) {
          var formData = new FormData();
          Object.keys(this.form).forEach(function (key) {
            if (_this.form[key]) {
              formData.append(key, _this.form[key]);
            }
          });
          this.form.attachments.forEach(function (attachment) {
            formData.append('attachments[]', attachment.file);
          });
          formData.append('grecaptcha_token', this.grecaptcha_token);
          axios.request({
            method: 'POST',
            url: "/wp-json/vq/v1/contact-form",
            data: formData,
            headers: {
              'content-type': 'multipart/form-data'
            }
          }).then(function (response) {
            _this.success = true;
            _this.form = {
              name: '',
              email: '',
              message: '',
              cv: '',
              letter: '',
              attachments: [{}],
              grecaptcha_token: ''
            };
            window.location.replace(_this.redirect);
          })["catch"](function (error) {
            console.log('error', error);
            _this.errors = _this.getErrors(error);
          });
        }
      }
    }
  });
}